module.exports = __webpack_public_path__ + "media/62.3d2228ea.mp3";